import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import AXIOS from "../../api/axios";
// import axios from "axios";
import { parseQuery, cookie } from "../../utils/tools";
import UA from "../../utils/ua";
import Toast from "../../utils/toast";

const queryPara = parseQuery(window.location.search.slice(1));
const returnUrl = `https://client.aircourses.com/h5/success`;

class Paylink extends Component {
  constructor(props) {
    super(props);
    this.payWeixin = this.payWeixin.bind(this);
    this.onBridgeReady = this.onBridgeReady.bind(this);
    this.payAli = this.payAli.bind(this);
  }
  // 公众号支付
  onBridgeReady(data) {
    // window.WeixinJSBridge.invoke('getBrandWCPayRequest', data)
    window.WeixinJSBridge.invoke("getBrandWCPayRequest", data, function (res) {
      if (res.err_msg === "get_brand_wcpay_request:ok") {
        // window.location.replace(`${returnUrl}?totalamount=${queryPara.totalamount}&success=1&channel=others`)
        window.location.replace(
          returnUrl +
            "?stuid=" +
            queryPara.userid +
            "&totalamount=" +
            queryPara.totalamount +
            "&success=1&channel=others&type=wait&orderno=" +
            queryPara.orderno
        );
        return;
      }
      // else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
      //     window.location.replace(returnUrl+"?stuid="+queryPara.userid+"&totalamount="+queryPara.totalamount+"&success=0&channel=others&type=wait&orderno="+queryPara.orderno)
      //     return;
      // } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
      //     window.location.replace(returnUrl+"?stuid="+queryPara.userid+"&totalamount="+queryPara.totalamount+"&success=0&channel=others&type=wait&orderno="+queryPara.orderno)
      //     return;
      // }
    });
  }
  // 获取微信订单
  payWeixin = (openid, isH5) => {
    let data = { orderNo: queryPara.orderno };
    if (isH5) {
      data.payType = "MWEB";
    } else {
      data.payType = "JSAPI";
      data.openid = openid;
    }
    AXIOS.payWeixin({ data: data }, (res, err) => {
      if (err) alert(err.errorMessage);
      else {
        if (isH5) {
          const { mwebUrl } = res.data;
          window.location.replace(mwebUrl);
        } else {
          if (typeof window.WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                () => {
                  this.onBridgeReady(res);
                },
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", () => {
                this.onBridgeReady(res);
              });
              document.attachEvent("onWeixinJSBridgeReady", () => {
                this.onBridgeReady(res);
              });
            }
          } else {
            this.onBridgeReady(res);
          }
        }
      }
    });
  };
  // 虚拟支付
  fakePay = (data) => {
    AXIOS.payTest({ data }, (res, err) => {
      if (err) Toast.info({ text: err.errorMessage });
      else {
        Toast.info({ text: "虚拟支付完成" });
      }
      this.setState({ refuseClick: false });
    });
  };
  //支付宝支付
  payAli() {
    const data = {
      // returnUrl:`${returnUrl}?totalamount=${queryPara.totalamount}&success=1&channel=others`,
      returnUrl: `${returnUrl}?stuid=${queryPara.userid}&orderno=${queryPara.orderno}&totalamount=${queryPara.totalamount}&success=1&channel=others&type=wait`,
      orderNo: queryPara.orderno,
      payType: "QUICK_WAP_PAY",
    };
    AXIOS.payAli({ data }, function (res) {
      document.getElementById("paylink_wrap").innerHTML = res.data;
      setTimeout(() => {
        document.forms[0].submit();
      }, 500);
    });
    // axios
    //   .post(`https://api.aircourses.com/ac-order/alipay`, data)
    //   .then(function (res) {
    //     document.getElementById("paylink_wrap").innerHTML = res.data;
    //     setTimeout(() => {
    //       document.forms[0].submit();
    //     }, 500);
    //   })
    //   .catch(function (err) {
    //     alert("error" + JSON.stringify(err));
    //   });
  }
  componentDidMount() {
    const {
      couponid,
      addressid,
      goodsno,
      userid,
      inviteawardpackid,
      channel,
    } = queryPara;
    const data = {
      stuCouponDetailIds: couponid !== "-1" ? [couponid] : [],
      goodsNo: goodsno,
      userId: userid,
      payType: UA.isWeixin ? "MWEB" : "QUICK_WAP_PAY",
      channelId: channel,
      version: 2, //接口版本
      addressId: addressid,
      saleType: typeof addressid === "undefined" ? 1 : 0,
      inviteAwardPackId: inviteawardpackid,
    };
    if (window.location.origin !== "https://client.aircourses.com") {
      return this.fakePay(data);
    }
    if (!queryPara.orderno) {
      // 获取订单号
      AXIOS.getWxOrder({ data }, (res, err) => {
        if (err) alert(err.errorMessage);
        else {
          window.location.replace(
            `${window.location.href}&orderno=${res.orderNo}&totalamount=${res.totalAmount}`
          );
        }
      });
    } else {
      if (UA.isWeixin) {
        const openid = cookie.get("openid") || queryPara.openid;
        if (!openid) {
          window.location.replace(
            `${window.location.origin}/weixin_callback${window.location.search}`
          );
          // alert(`${window.location.origin}/weixin_callback${window.location.search}`)
        } else {
          cookie.set("openid", openid, 1);
          this.payWeixin(openid, false);
        }
      } else {
        this.payAli();
      }
    }
  }

  render() {
    return (
      <DocumentTitle title={"爱课AirCourse"}>
        <React.Fragment>
          <div id="paylink_wrap">{/* {JSON.stringify(queryPara)} */}</div>
        </React.Fragment>
      </DocumentTitle>
    );
  }
}

export default Paylink;



// WEBPACK FOOTER //
// ./src/components/payPage/Paylink.jsx